import * as PIXI from "pixi.js"

export default class PixiUtil {

    /**
     * Диапазон:
     */
    public static clamp = (min:number, val:number, max:number) => Math.min(Math.max(min, val), max);

    /**
     * Линейный градиент:
     * data: Array<[number, string]> = [[0, '#ff0000'],[0.5, '#00ff00'],[1, '#0000ff']];
     */
    public static createLinearGradient(data: Array<[number, string]>): PIXI.Sprite
    {
        function linGradTexture(data: Array<[number, string]>): PIXI.Texture
        {
            let texture = PIXI.Texture.WHITE;
            const cnv = document.createElement('canvas');
            const ctx = cnv.getContext('2d');
            if (ctx) {
                const grd = ctx.createLinearGradient(0,0, 100, 0);
                Array.from(data).forEach((stop: [number, string]) => {
                    grd.addColorStop(stop[0], stop[1]);
                });
                ctx.fillStyle = grd;
                ctx.fillRect(0,0, 100, 100);
                texture = PIXI.Texture.from(cnv);
            }
            return texture;
        }
        return new PIXI.Sprite(linGradTexture(data));
    }

    /**
     * HSL цвет:
     * h: hue, s: saturation, l: lightness
     */
    public static hsl2hex(h:number, s:number = 1, l:number = 0.5): number
    {
        // input: h in [0,360] and s,v in [0,1] - output: r,g,b in [0,1]
        function hsl2rgb(h:number, s:number, l:number)
        {
            let a = s*Math.min(l,1-l);
            let f = (n:number, k=(n+h/30)%12) => l-a*Math.max(Math.min(k-3,9-k,1),-1);
            return [f(0),f(8),f(4)];
        }
        return PIXI.utils.rgb2hex(hsl2rgb(h,s,l));
    }

    public static hex2hsl(hex: number): Array<number>
    {
        // in: r,g,b in [0,1], out: h in [0,360) and s,l in [0,1]
        function rgb2hsl(r:number, g:number, b:number) {
            let v = Math.max(r,g,b), c=v-Math.min(r,g,b), f=(1-Math.abs(v+v-c-1));
            let h = c && ((v==r) ? (g-b)/c : ((v==g) ? 2+(b-r)/c : 4+(r-g)/c));
            return [60*(h<0?h+6:h), f ? c/f : 0, (v+v-c)/2];
        }
        const rgb = PIXI.utils.hex2rgb(hex);
        return rgb2hsl(rgb[0], rgb[1], rgb[2]);
    }

    /**
     * HSV цвет:
     * h: hue, s: saturation, v: value (brightness)
     */
    public static hsv2hex(h:number, s:number = 1, v:number = 1): number
    {
        // input: h in [0,360] and s,v in [0,1] - output: r,g,b in [0,1]
        function hsv2rgb(h:number, s:number, v:number)
        {
            let f = (n:number, k=(n+h/60)%6) => v - v*s*Math.max( Math.min(k,4-k,1), 0);
            return [f(5),f(3),f(1)];
        }
        return PIXI.utils.rgb2hex(hsv2rgb(h,s,v));
    }

    public static hex2hsv(hex: number): Array<number>
    {
        // input: r,g,b in [0,1], out: h in [0,360) and s,v in [0,1]
        function rgb2hsv(r:number, g:number, b:number) {
            let v = Math.max(r,g,b), c=v-Math.min(r,g,b);
            let h = c && ((v==r) ? (g-b)/c : ((v==g) ? 2+(b-r)/c : 4+(r-g)/c));
            return [60*(h<0?h+6:h), v&&c/v, v];
        }
        const rgb = PIXI.utils.hex2rgb(hex);
        return rgb2hsv(rgb[0], rgb[1], rgb[2]);
    }

    public static delay(ms: number) {
        return new Promise((resolve, reject) => {
            setTimeout(resolve, ms);
        });
    }
}
